import AudioPopUpCard from './AudioPopUpCard'

export default AudioPopUpCard
